"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (boxPosition, props) => {
  const {
    anchorWidth,
    header
  } = props;
  const {
    fontFamily,
    basicFontSize,
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _useStylesUtils.useStylesUtils)();
  const getBoxPosition = () => {
    if (boxPosition === 'inline-start') {
      if (direction === 'rtl') {
        return 'right';
      }
      return 'left';
    } else if (boxPosition === 'inline-end') {
      if (direction === 'rtl') {
        return 'left';
      }
      return 'right';
    } else {
      return boxPosition;
    }
  };
  const position = getBoxPosition();
  const ccTooltipStyle = (0, _react.useMemo)(() => {
    const positionProps = () => {
      switch (position) {
        case 'bottom':
          return {
            paddingTop: pxToRem(13)
          };
        case 'top':
          return {
            paddingBottom: pxToRem(13)
          };
        case 'left':
          return {
            paddingRight: pxToRem(13)
          };
        case 'right':
          return {
            paddingLeft: pxToRem(13)
          };
        default:
          return {};
      }
    };
    const arrowPositionProps = () => {
      switch (position) {
        case 'bottom':
          return {
            top: pxToRem(12),
            bottom: 'unset',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-135deg)',
            backgroundColor: header ? themeColors?.general.border : themeColors?.general.light
          };
        case 'top':
          return {
            top: 'unset',
            bottom: pxToRem(12),
            left: '50%',
            transform: `translate(-50%, 50%) rotate(45deg)`
          };
        case 'left':
          return {
            top: '50%',
            bottom: 'unset',
            left: `calc(100% - ${pxToRem(12)})`,
            transform: 'translate(-50%, -50%) rotate(-45deg)'
          };
        case 'right':
          return {
            top: '50%',
            bottom: 'unset',
            left: pxToRem(12),
            transform: 'translate(-50%, -50%) rotate(135deg)'
          };
        default:
          return {};
      }
    };
    const ccTooltip = (0, _css.css)({
      fontFamily: fontFamily,
      display: anchorWidth === 'auto' ? 'block' : 'inline-block',
      position: 'relative',
      userSelect: 'none'
    });
    const ccTooltipHeader = (0, _css.css)({
      overflow: 'hidden',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: pxToRem(6),
      background: themeColors?.general.border,
      borderTopLeftRadius: pxToRem(10),
      borderTopRightRadius: pxToRem(10)
    });
    const ccTooltipContent = (0, _css.css)({
      position: 'relative',
      fontSize: basicFontSize,
      margin: '0 auto',
      width: 'fit-content',
      ...positionProps(),
      '&::before': {
        content: '""',
        border: `solid 1px ${themeColors?.general.border}`,
        backgroundColor: themeColors?.general.light,
        borderWidth: '0 1px 1px 0',
        display: 'inline-block',
        padding: pxToRem(4),
        position: 'absolute',
        zIndex: 1,
        ...arrowPositionProps()
      }
    });
    const ccTooltipInnerContent = (0, _css.css)({
      padding: `0 ${pxToRem(4)}`
    });
    return {
      ccTooltip,
      ccTooltipHeader,
      ccTooltipContent,
      ccTooltipInnerContent
    };
  }, [basicFontSize, fontFamily, position, anchorWidth, header, pxToRem, themeColors?.general.border, themeColors?.general.light]);
  return {
    'cc-Tooltip': ccTooltipStyle.ccTooltip,
    'cc-Tooltip__header': ccTooltipStyle.ccTooltipHeader,
    'cc-Tooltip__content': ccTooltipStyle.ccTooltipContent,
    'cc-Tooltip__inner-content': ccTooltipStyle.ccTooltipInnerContent
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;